import axiosCore from "axios";
import { getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import store from "../store";
// import "firebase/compat/auth";
export default class FBAxios {
  get instance() {
    return this.axiosInstance;
  }
  set instance(instance) {
    this.axiosInstance = instance;
  }
  constructor(url, region, msTimeout) {
    this.options = getApp().options;
    if (region) {
      this.region = region;
    } else {
      this.region = "us-central1";
    }
    if (url) {
      this.useEmulator(url);
    } else {
      this.useProduction();
    }
    this.msTimeout = msTimeout || 3600000;

    this.axiosInstance = axiosCore.create({
      headers: {
        "Content-Type": "text/plain",
      },
      transformRequest: (data, headers) => {
        if (headers["Content-Type"] == "text/plain") {
          return JSON.stringify(data);
        } else {
          return data;
        }
      },
    });
  }
  async call(fn, data, headers) {
    // envia el tenant en cada funcion
    if (!data.tenant) {
      data.tenant = this.tenant;
    }
    const sendData = {
      headers: headers ? headers : {},
      data: data ? data : {},
    };


    const user = await store.getters.getFirebaseApp.auth
      .getCurrentUserFirstTime;
    if (user) {
      const token = await user.getIdToken();
      sendData.headers.authorization = `Bearer ${token}`;
    }
    let response;
    if (this.msTimeout) {
      //response = await timedOutPromise(this.msTimeout, this.axiosInstance.post(this.url + fn, sendData))
      response = await Promise.race([
        timedoutreject(
          this.msTimeout,
          new Error("La respuesta tardo mucho en devolver informacion")
        ),
        this.axiosInstance.post(this.url + fn, sendData, {
          headers: sendData.headers,
        }),
      ]);
    } else {
      response = await this.axiosInstance.post(this.url + fn, sendData, {
        headers: sendData.headers,
      });
    }

    return response.data;
  }
  async callForm(fn, data, headers) {
    // envia el tenant en cada funcion
    if (!data.tenant) {
      data.tenant = this.tenant;
    }

    /*const sendData = {
      headers: headers ? headers : {},
      data: data ? data : {}
    };*/

    const user = await store.getters.getFirebaseApp.auth
      .getCurrentUserFirstTime;
    if (user) {
      const token = await user.getIdToken();
      headers.authorization = `Bearer ${token}`;
    }
    let response;
    if (this.msTimeout) {
      //response = await timedOutPromise(this.msTimeout, this.axiosInstance.post(this.url + fn, sendData))
      response = await Promise.race([
        timedoutreject(
          this.msTimeout,
          new Error("La respuesta tardo mucho en devolver informacion")
        ),
        this.axiosInstance.post(this.url + fn, data, {
          headers: headers,
        }),
      ]);
    } else {
      response = await this.axiosInstance.post(this.url + fn, data, {
        headers:headers,
      });
    }

    return response.data;
  }
  setTenant(tenant) {
    this.tenant = tenant;
    return this;
  }
  changeRegion(region) {
    this.region = region;
    return this;
  }
  useProduction() {
    this.url = `https://${this.region}-${this.options.projectId}.cloudfunctions.net/`;
    return this;
  }
  useEmulator(url) {
    this.url = `${url}/${this.options.projectId}/${this.region}/`;
    return this;
  }
  useCustomUrl(url) {
    this.url = `${url}/`;
    return this;
  }
}

function timedoutreject(ms, err) {
  return new Promise(function(res, rej) {
    setTimeout(function() {
      rej(err);
    }, ms);
  });
}

function timedOutPromise(ms, promise) {
  return new Promise(function(resolve, reject) {
    promise.then(function(val) {
      resolve(val);
    });
    setTimeout(function() {
      reject({
        data: {
          ok: false,
          message: "Prueba",
        },
      });
    }, ms);
  });
}
